class DropdownHover {
  constructor() {
    this.init();
  }

  init() {
    // Only run on desktop
    if (window.innerWidth < 750) return;

    const detailsElements = document.querySelectorAll('.header__inline-menu details:not(.header__search details)');
    
    detailsElements.forEach(details => {
      const summary = details.querySelector('summary');
      let timeoutId;
      
      // Add hover event listeners
      details.addEventListener('mouseenter', () => {
        clearTimeout(timeoutId);
        if (!details.hasAttribute('open')) {
          details.setAttribute('open', '');
        }
      });

      details.addEventListener('mouseleave', (e) => {
        // Check if we're moving to a child element
        const relatedTarget = e.relatedTarget;
        if (relatedTarget && details.contains(relatedTarget)) {
          return; // Don't close if moving to a child element
        }
        
        // Add a small delay before closing
        timeoutId = setTimeout(() => {
          if (details.hasAttribute('open')) {
            details.removeAttribute('open');
          }
        }, 100);
      });

      // Prevent summary click from closing on desktop
      summary.addEventListener('click', (e) => {
        if (window.innerWidth >= 750) {
          e.preventDefault();
        }
      });
    });
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new DropdownHover();
}); 